export default "__VITE_ASSET__DJ4Txgt2__"